/**
 * dots.jsx
 *
 * @Author: bjzhuwei
 * @Date: 2017/8/18 22:52
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * @ignore
 * */
class SmallImgIndex extends React.PureComponent {
    static propTypes = {
        type: PropTypes.string,
        len: PropTypes.number,
        imgList: PropTypes.array,
        activeIndex: PropTypes.number,
        smallImgWidth: PropTypes.number,
        smallImgHeight: PropTypes.number,
        handleClick: PropTypes.func,
        hover: PropTypes.bool,
        imgGap: PropTypes.number,
    };

    static defaultProps = {
        imgList: [],
        activeIndex: 1,
        smallImgWidth: 64,
        smallImgHeight: 64,
        imgGap: 8,
        handleClick: rs => console.log(rs),
        hover: false,
    };

    render() {
        const {
            len,
            smallImgList,
            activeIndex,
            imgWidth,
            smallImgWidth,
            imgGap,
            handleClick,
            display,
            left,
        } = this.props;
        const smallImgContainerWidth = len * smallImgWidth + imgGap * (len - 1);
        const imgInnerStyle = {
            width: `${smallImgContainerWidth}px`,
            transform: `translateX(${left}px)`,
            boxSizing: 'content-box',
        };

        return (
            <div className="img-index-container" style={{ width: `${imgWidth}px` }} ref={e => (this.dots = e)}>
                {len !== 1 && display ? (
                    <div className="smallImg" style={imgInnerStyle}>
                        {smallImgList.map((item, index) => {
                            const currentIndex = index + 1;
                            const className =
                                activeIndex === currentIndex ? 'smallImg-item smallImg-on' : 'smallImg-item';
                            const styleContainer = {
                                width: `${smallImgWidth}px`,
                                height: `${smallImgWidth}px`,
                                background: `url(${item.img}) no-repeat center`,
                                backgroundSize: 'cover',
                            };
                            return (
                                <div
                                    className={className}
                                    style={styleContainer}
                                    key={currentIndex}
                                    onClick={() => handleClick(currentIndex)}/>
                            );
                        })}
                    </div>
                ) : null}
            </div>
        );
    }
}
export default SmallImgIndex;



// WEBPACK FOOTER //
// ./src/carousel/SmallImgIndex.jsx